module.exports = __webpack_public_path__ + "a9d89b9e1988b1c71a833baece2e7558.jpg";